export var SearchType;
(function (SearchType) {
    SearchType["Customer"] = "customer";
    SearchType["Partner"] = "partner";
})(SearchType || (SearchType = {}));
